<!-- DApp分组容器，在不同尺寸屏幕上显示不同数量，可包含H2级Title -->

<template>
  <div v-if="list && list.length > 0" class="dapp-item-group">
    <slot name="title"></slot>
    <div class="dapp-item-group-content row">

      <template v-if="biggerItem">
        <div v-for="data in list" class="dapp-item-group-item col-12 col-sm-12 col-md-6 col-lg-6 mb-4">
          <slot name="item" :data="data"></slot>
        </div>
      </template>

      <template v-else>
        <div v-for="data in list" class="dapp-item-group-item col-12 col-sm-12 col-md-6 col-lg-3 mb-4">
          <slot name="item" :data="data"></slot>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'DAppGroup',
    props: ['list', 'biggerItem'],
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/widgets/DAppGroup.vue